import AppService from "./app-service"

export default class SupplierService extends AppService {

  constructor() {
    super({ path: "suppliers" })
  }
}